(ns bp-libs.design-system.components.carousel)

(defn- thumb-container
  [{:keys [on-focus on-blur tab-index] :as _events} thumb]
  [:div {:tab-index tab-index
         :on-focus on-focus
         :on-blur on-blur
         :class ["select-none shrink-0 snap-always rounded-lg outline-none my-2 mx-1"
                 "thumb snap-center"]}
   thumb])

(defn carousel
  "Carousel for thumbs. Uses native scroller or transform: translateX depending on the config.
  A wrapper component is recommended for fine tuning its control.
  :use-3d? for controlling whether you want to control with a transform instead of scroll via --val property
  :step-3d is the amount of the UI will translate, defaults to 17.5vw
  :infinite? to repeat items in the carousel
  :infinite-count to control how many items should be repeated, defaults to 5."
  [{:keys [thumbs react-ref use-3d? infinite? infinite-count on-transition-end scroll-div-class] :as props}]
  (let [styles {}
        repeated (when infinite? (->> thumbs (take (or infinite-count 5)) vec))
        all-thumbs (apply merge thumbs repeated)]
    [:div {:class "flex items-center place-content-center"}
     [:div {:class "w-full overflow-hidden"}
      (into [:div {:ref react-ref
                   :on-transition-end on-transition-end
                   :style styles
                   :class ["flex"
                           scroll-div-class
                           "scroll-px-2 scroll-ps-2 snap-proximity snap-x hide-scroll-bar"
                           (if use-3d?
                             "duration-500 transition-transform will-change-transform"
                             "overflow-x-auto will-change-scroll scroll-smooth")]}]
            (mapv (partial thumb-container props) all-thumbs))]]))
